export const DASHBOARD_STATES = {
    PAGE_LOADING: "loading",
    PAGE_READY: "Ready"
}

export const DASHBOARD_STATES_MESSAGE_MAP = {
    [DASHBOARD_STATES.PAGE_LOADING]: "",
    [DASHBOARD_STATES.PAGE_READY]: "",
}

export const COOKIES_SETTING_PATHS = ['/account', "/support"]

export const APP_PRODUCTION_URL = "https://web.tax1099.com/"